import { ContainersButtonsGroup, CustomButtonV2 } from "../../../../pages/styles";
import { BackdropLoading } from "../../../BackdropLoading";
import { Body, Container, CustomChip, Footer, Header, Subtitle, TextType, Title } from "./styles";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";


export const QrModalCard = ({ data = { title: '', type: '', code: '' }, loading, qrUrl, handleCloseQr }) => {

    const { t } = useTranslation();

    return (
        <Container>
            <Header>{t('asset.qrTitleModal')}</Header>
            <Body>
                {loading ? (
                    <p>...</p>
                ) : (
                    <>
                        {qrUrl && (
                            <>
                                <Grid container justifyContent="center" alignItems="center" sx={{ margin: "15px 0" }}>
                                    {data.type && (
                                        <Grid item xs={12} textAlign="center">
                                            <CustomChip
                                                label={<TextType>{data.type}</TextType>}
                                                size="small"
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} textAlign="center">
                                        <Title>{data.code}</Title>
                                    </Grid>
                                    <Grid item xs={12} textAlign="center">
                                        <Subtitle>{data.title}</Subtitle>
                                    </Grid>
                                </Grid>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        backgroundColor: "#fff",
                                        borderRadius: 3,
                                        padding: 0,
                                        border: "3px solid #D6E2F0",
                                        width: "fit-content",
                                        margin: "0 auto",
                                        mb: 2
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={qrUrl}
                                        alt="QR"
                                        sx={{
                                            width: 300,
                                            height: 300,
                                            objectFit: "contain",
                                            backgroundColor: "white",
                                            padding: 0,
                                            borderRadius: 1
                                        }}
                                    />  
                                </Box>
                            </>
                        )}
                    </>
                )}
            </Body>
            <Footer>
                <ContainersButtonsGroup twoContainers={true}>

                    <CustomButtonV2
                        btnType="secondary"
                        onClick={handleCloseQr}
                    >
                        {t('common.cancel')}
                    </CustomButtonV2>
                  
                    <CustomButtonV2
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = qrUrl;
                            link.download = 'QR.png';
                            link.click();
                        }}
                    >
                        {t('common.download')}
                    </CustomButtonV2>
        
                </ContainersButtonsGroup>
            </Footer>
            <BackdropLoading open={loading} />
        </Container>
    )
}